import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { USER_ROLE_OPTIONS } from './helpers';

export const UserRoleSelect = ({
	value = '',
	onChange,
	includeAllOption = true,
	disabled = false,
	size = 'small',
	fullWidth = true,
	displayEmpty = true,
	...props
}) => {
	return (
		<FormControl size={size} fullWidth={fullWidth} disabled={disabled}>
			<Select value={value} displayEmpty={displayEmpty} onChange={onChange} {...props}>
				{includeAllOption && <MenuItem value=''>All roles</MenuItem>}
				{USER_ROLE_OPTIONS.map((option) => (
					<MenuItem key={option} value={option}>
						{option}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};

export default UserRoleSelect;
